var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-items"},_vm._l((_vm.labels),function(label,index){return _c('div',{key:index,class:{ active: label === _vm.highlightedItem }},[_vm._v(_vm._s(label))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }